import Input from "../Common/Forms/Input";
import ButtonPrimary from "../Common/Buttons/ButtonPrimary";
import Checkbox from "../Common/Forms/Checkbox";
import { globalStores } from "../api/globalStores";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { observer } from "mobx-react";
import { FlowElementProps } from "./OnboardingFlow";
import { useNavigate } from "react-router-dom";
import Modal from "../Common/Utility/Modal";
import PrivacyPolicy from "./PrivacyPolicy";
import IconCross from "../Common/Icons/IconCross";
import useCountryCity from "../Common/Forms/Helpers/useCountryCity";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.min.css";
import { getMinTelNumberString } from "../Common/Utility/helpers";

const errorMap = [
  "Invalid number",
  "Invalid country code",
  "Too short",
  "Too long",
  "Invalid number",
];

export const ParentDetails2 = observer(() => {
  const navigate = useNavigate();
  const [metaData, setMetaData] = useState<{
    originCountry?: string | null;
    city?: string | null;
    referralCode?: string | null;
    contactNumber?: string | null;
    privacyPolicyAccepted?: boolean | null;
  }>({
    originCountry: globalStores.parentStore.userDetail.originCountry,
    city: globalStores.parentStore.userDetail.city,
    referralCode: globalStores.parentStore.userDetail.referralCode,
    contactNumber: globalStores.parentStore.parentDetail.contactNumber,
    privacyPolicyAccepted:
      globalStores.parentStore.parentDetail.privacyPolicyAccepted,
  });
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);

  const { possibleCountries, possibleCities, validCity, validCountry } =
    useCountryCity(metaData.originCountry ?? "", metaData.city ?? "");

  const submitMetaData = async () => {
    if (!metaData.privacyPolicyAccepted) {
      throw new Error("You must accept the privacy policy to continue");
    }
    if (!metaData.originCountry || !validCountry) {
      throw new Error("Please enter a valid origin country!");
    }
    if (!metaData.city || !validCity) {
      throw new Error("Please enter a valid city!");
    }
    if (
      !metaData.contactNumber ||
      !telInputRef.current ||
      !intlTelInputInstance
    ) {
      throw new Error("Please fill in your contact number!");
    }

    //validating phone number
    console.log("Value", telInputRef.current.value);
    telInputRef.current.value = telInputRef.current.value
      .trim()
      .substring(
        intlTelInputInstance.getSelectedCountryData().dialCode.length + 1
      )
      .trim();
    console.log("Value", telInputRef.current.value);
    const isNumberValid = intlTelInputInstance.isValidNumber();
    telInputRef.current.value = `+${
      intlTelInputInstance.getSelectedCountryData().dialCode
    } ${telInputRef.current.value}`;
    console.log("Value", telInputRef.current.value);

    if (!isNumberValid) {
      throw new Error(`Please enter a valid contact number!`);
    } else {
      console.log("Yay valid number!");
    }

    await globalStores.parentStore.acceptPrivacyPolicy();
    await globalStores.parentStore.submitMetaData(
      metaData.originCountry,
      metaData.city,
      metaData.contactNumber
    );
    navigate("/parent/flow/child_details");
  };

  //for tel input
  const telInputRef = useRef<HTMLInputElement | null>(null);
  const [intlTelInputInstance, setIntlTelInputInstance] =
    useState<intlTelInput.Plugin>();

  useEffect(() => {
    if (telInputRef.current) {
      const init = intlTelInput(telInputRef.current, {
        preferredCountries: ["sg", "id"], //set Singapore and Indonesia to be the preferred countries.
        utilsScript:
          "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
      });
      setIntlTelInputInstance(init);

      return init.destroy;
    }
  }, [telInputRef]);

  console.log("Current number:", metaData.contactNumber);

  return (
    <>
      <Modal
        open={privacyPolicyOpen}
        onClose={() => {
          setPrivacyPolicyOpen(false);
        }}
      >
        <div className="bg-brij-White max-w-2xl p-8 h-[520px] flex flex-col gap-8 rounded-2xl">
          <div className="flex w-full justify-between">
            <h1
              className="text-heading2"
              id="brij-privacy-policy-text-temporary-"
            >
              BrijEdu Privacy Policy
            </h1>
            <button
              onClick={() => {
                setPrivacyPolicyOpen(false);
              }}
              className="w-6 h-6 stroke-brij-Black stroke-2"
            >
              <IconCross />
            </button>
          </div>
          <PrivacyPolicy />
        </div>
      </Modal>
      <p className="text-xl pb-4 pl-3 text-center">
        Please input your <b>Parent</b> details
      </p>
      <Input
        value={metaData.originCountry ?? ""}
        default={metaData.originCountry ?? ""}
        onChange={(originCountry) =>
          setMetaData({ ...metaData, originCountry })
        }
        type="autocomplete"
        placeholder="Country"
        options={possibleCountries.map((country) => ({
          value: country,
          label: country,
          handleLabel: () => {},
          handleValue: () =>
            setMetaData({ ...metaData, originCountry: country }),
        }))}
        icon="globe"
      />
      <Input
        value={metaData.city ?? ""}
        default={metaData.city ?? ""}
        onChange={(city) => setMetaData({ ...metaData, city })}
        options={possibleCities.map((city) => ({
          value: city,
          label: city,
          handleLabel: () => {},
          handleValue: () => setMetaData({ ...metaData, city }),
        }))}
        type="autocomplete"
        placeholder="City of Residence"
        icon="city"
      />
      <Input
        default={metaData.contactNumber ?? ""}
        onChange={(contactNumber) => {
          setMetaData({
            ...metaData,
            contactNumber: getMinTelNumberString(
              intlTelInputInstance,
              contactNumber
            ),
          });
          console.log({ contactNumber });
        }}
        value={getMinTelNumberString(
          intlTelInputInstance,
          metaData.contactNumber ?? ""
        )}
        type="tel"
        placeholder="Parent's Contact Number"
        inputRef={telInputRef}
      />
      <label className="flex gap-2 py-4 px-3">
        <Checkbox
          default={metaData.privacyPolicyAccepted ?? false}
          onChange={(privacyPolicyAccepted) =>
            setMetaData({ ...metaData, privacyPolicyAccepted })
          }
        />
        I agree to the{" "}
        <span
          className="underline font-semibold cursor-pointer"
          onClick={() => {
            setPrivacyPolicyOpen(true);
          }}
        >
          Privacy Policy
        </span>
      </label>
      <ButtonPrimary
        onClick={() => {
          toast.promise(submitMetaData(), {
            loading: "Submitting Parent Details",
            error: (e: any) => e.message,
            success: "Parent Details Updated!",
          });
        }}
      >
        Sign Up
      </ButtonPrimary>
      {/* <div className="flex justify-center py-4 px-2">
        <button
          onClick={() => navigate("/student/login")}
          className="text-brij-DarkGrey hover:text-brij-Black"
        >
          BACK
        </button>
      </div> */}
    </>
  );
});
